
import { motion } from "framer-motion";
import { Trophy, Shield, Star } from "lucide-react";

const PricingHeader = () => {
  return (
    <div className="text-center mb-12">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-corporate-primary-25 text-corporate-primary-100 mb-6 mx-auto">
        <Trophy className="w-4 h-4" />
        <span className="text-sm font-medium">Access Verified Strategies</span>
      </div>
      
      <h1 className="text-3xl sm:text-4xl font-bold text-corporate-primary-100 mb-6 leading-tight">
        Upgrade to METRADE Premium for Enhanced Trading
      </h1>
      
      <div className="flex flex-col items-center gap-4">
        <p className="text-corporate-neutral-75 max-w-3xl mx-auto px-4 text-lg">
          Join our community of successful traders using METRADE Premium strategies.
          Get access to extensively tested and verified trading strategies with proven track records.
        </p>
        
        <div className="flex flex-wrap justify-center items-center gap-3 mt-4 text-sm text-corporate-neutral-75">
          <div className="flex items-center gap-1 bg-corporate-primary-25 px-3 py-1.5 rounded-full">
            <Shield className="w-4 h-4 text-corporate-primary-75" />
            <span>Verified Strategies</span>
          </div>
          <div className="flex items-center gap-1 bg-corporate-secondary-25 px-3 py-1.5 rounded-full">
            <Star className="w-4 h-4 text-corporate-secondary-100" />
            <span>Premium Support</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingHeader;
